module.exports = __webpack_public_path__ + "media/assets/CHECK-thick-white.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/assets/CHECK-thick-white.svg
// module id = 23
// module chunks = 0